export default __webpack_public_path__ + "90b41a6c5945491f92ae5801a607e85b.png";